import { globalStore } from "../../main.js";

export default {
  name: "dashboardHome",
  data() {
    return {
      dashBoardDigiLinks: globalStore.dashBoardDigiLinks,
      dashBoardMMPLinks: globalStore.dashBoardMMPLinks
    };
  },
  beforeCreate: function() {
    if (!this.$session.exists()) {
      this.$router.push("login");
    }
  },
  created: function() {
    (globalStore.openedSubPoint = this.openedSubPoint),
      (globalStore.openedPoint = this.openedPoint);
  },
  methods: {
    userInGroup: function(groupName){
      var user = this.$session.get('user');
      var groups = user.Groups;
      if(groups){
        return user.Groups.indexOf(groupName) > -1;
      }
      return false;
    },
    userHasSharePoint: function(){
      var user = this.$session.get('user')
			return user != null && user.HasSharePointGroups;
    },
    userHasDigi: function(){
      var user = this.$session.get('user')
			return user != null && user.HasDigiGroups;
		},
    userHasMMPDigi: function(){
      var user = this.$session.get('user')
			return user != null && user.HasMMPDigiGroups;
		}
  },
  computed: {
    openedSubPoint: function() {
      return (this.isCurrentUserAdmin || this.isCurrentUserMMPWM) ? this.labels.APPLICATIONS_TEXT : this.labels.MY_APPLICATIONS_TEXT;
    },
    openedPoint: function() {
      return this.labels.ACTION_TEXT;
    },
    digiLink: function() {
      return globalStore.digiUrl + "login";
    },
    mmpLink: function() {
      return globalStore.mmpUrl + "login";
    },
    isCurrentUserAdmin: function(){
      return globalStore.isCurrentUserAdmin;
    },
    isCurrentUserMMPWM: function() {
      return globalStore.isCurrentUserMMPWM;
    },
    labels: function() {
        return globalStore.culture.strings.DashboardHome;
    }
  }
};


// WEBPACK FOOTER //
// ./src/components/DashboardHome/DashboardHome.js